import { StandardButton } from "../atoms/buttons";
import { GridLayout } from "../components/layout";
import hex_is_light from "../api/is_light_color";

export default function ThemePaletPicker({options, onSwitch}) {
    return (
        <>
            <p className="phone-no-margin-left" style={{"color": "var(--grey-800)", "fontSize": "14px", "margin": "0px 1rem 0.5rem 1rem", "fontWeight": "bold"}}>Kies een thema</p>
            <GridLayout className="phone-no-margin-left phone-no-margin-right" gap="1rem" columnsTemplate="repeat(auto-fit, minmax(100px, 1fr))" style={{"margin": "0px 1rem 1rem 1rem"}}>
                {options.map((item, index) => {
                    return (
                        <button className="button-comp small-button small-rounded" style={{"margin": "0px", "padding": "0.5rem", "width": "100%", "justifyContent": "center", color: (!hex_is_light(item.colors.primary) ? "white" : "black"), "backgroundColor": item.colors.primary}} onClick={() => onSwitch(item.colors)}>{item.name}</button>
                    )
                })}
            </GridLayout>
        </>
    )
}